module.exports = __webpack_public_path__ + "img/emperor.9b4d1245.png";